import React, { useState } from "react";
import Breadcrumb from "../../../../core/common/Breadcrumb/breadcrumb";
import { Link } from "react-router-dom";
import ProfileCard from "../../common/profileCard";
import StudentSidebar from "../../common/studentSidebar";
import SettingsLinks from "../settingsLinks/settingsLinks";
import SettingsModal from "../settingsModal/settingsModal";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { User } from "../../../../core/types/types";
import { updateUser } from "../../../../core/redux/authSlice";
import CustomSelect from "../../../../core/common/commonSelect";
import { Country, GradingScheme, LevelOfEducation } from "../../../../core/common/selectOption/json/selectOption";
import apiInstance from "../../../../utility/apiInstance";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const StudentWorkExperience = () => {

    const user = useSelector((state: any) => state.auth.user);
    const dispatch = useDispatch();

    const [msg, setMsg] = useState({
        error: false,
        loading: false,
        text: ''
    });

    const [formData, setFormData] = useState<User>({
        id: user?.id || '',
        workExperience: user?.workExperience || [],
    })

    const [dateErrors, setDateErrors] = useState<string[]>([]);

    const getModalContainer = () => {
        const modalElement = document.getElementById("add_assignment");
        return modalElement ? modalElement : document.body;
    };

    const updateProfile = async (e: any) => {
        e.preventDefault();

        if (dateErrors.some(Boolean)) {
            setMsg({ error: true, loading: false, text: 'Please fix date errors before saving.' });
            return;
        }

        setMsg({
            error: false,
            loading: true,
            text: ''
        });

        try {
            const response = await apiInstance.patch(`/api/users/${formData.id}`, formData)
            dispatch(updateUser(response.data.doc))
            setMsg({
                error: false,
                loading: false,
                text: 'Details updated successfully!'
            });

        } catch (error: any) {
            setMsg({
                error: true,
                loading: false,
                text: error.message
            });
        }
    }

    const addWorkExp = () => {
        setFormData({
            ...formData,
            workExperience: [
                ...(formData.workExperience || []),
                {
                    employer: '',
                    jobTitle: '',
                    location: '',
                    from: undefined,
                    to: undefined,
                    stillWorking: 'no',
                    description: ''
                }
            ]
        });
    }

    const updateWorkExp = (index: number, data: any) => {
        const updatedWorkExp = formData.workExperience?.map((work, i) => {
            if (i === index) {
                return { ...work, [data.name]: data.value };
            } else {
                return work;
            }
        });

        const updatedWork = updatedWorkExp?.[index];
        const newDateErrors = [...dateErrors];
        if (updatedWork) {
            const from = data.name === 'from' ? data.value : updatedWork.from;
            const to = data.name === 'to' ? data.value : updatedWork.to;
            if (from && to && new Date(to) < new Date(from)) {
                newDateErrors[index] = 'End Date cannot be earlier than Start Date.';
            } else {
                newDateErrors[index] = '';
            }
        }
        setDateErrors(newDateErrors);

        setFormData({ ...formData, workExperience: updatedWorkExp });
    }

    const deleteWorkExp = (index: number) => {
        const updatedWorkExp = formData.workExperience?.filter((work, i) => i !== index);
        setFormData({
            ...formData,
            workExperience: updatedWorkExp
        });
    }

    return (
        <>
            <div className="content">
                <div className="container">
                    {/* Profile */}
                    <ProfileCard />
                    {/* /Profile */}
                    <div className="row">
                        {/* Sidebar */}
                        <StudentSidebar />
                        {/* Sidebar */}
                        <div className="col-lg-9">
                            <div className="mb-3">
                                <h5>Settings</h5>
                            </div>
                            <SettingsLinks />
                            <div className="card">
                                <div className="card-body">
                                    <div>
                                        <div className="edit-profile-info mb-3">
                                            <h5 className="mb-1">Work Experience</h5>
                                        </div>


                                        {formData?.workExperience?.length ? (
                                            formData?.workExperience?.map((work, index) => (

                                                <div key={index} className="card">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="d-flex justify-content-end mt-3">
                                                                <i className="cursor-pointer isax isax-trash text-danger" onClick={() => deleteWorkExp(index)}></i>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Job Title
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        defaultValue=""
                                                                        name="jobTitle"
                                                                        value={work.jobTitle || ''}
                                                                        onChange={(e) => {
                                                                            updateWorkExp(index, {
                                                                                name: e.target.name,
                                                                                value: e.target.value
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Employer
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        defaultValue=""
                                                                        name="employer"
                                                                        value={work.employer || ''}
                                                                        onChange={(e) => {
                                                                            updateWorkExp(index, {
                                                                                name: e.target.name,
                                                                                value: e.target.value
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Location
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        defaultValue=""
                                                                        name="location"
                                                                        value={work.location || ''}
                                                                        onChange={(e) => {
                                                                            updateWorkExp(index, {
                                                                                name: e.target.name,
                                                                                value: e.target.value
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Start Date
                                                                    </label>
                                                                    <div className="input-icon-start position-relative">
                                                                        <span className="input-icon-addon">
                                                                            <i className="isax isax-calendar" />
                                                                        </span>

                                                                        <DatePicker
                                                                            name="from"
                                                                            className="form-control datetimepicker"
                                                                            getPopupContainer={getModalContainer}
                                                                            placeholder="Select Date"
                                                                            format="DD/MM/YYYY"
                                                                            onChange={(date) => {
                                                                                updateWorkExp(index, {
                                                                                    name: 'from',
                                                                                    value: date ? date.format('YYYY-MM-DD') : ''
                                                                                });
                                                                            }}
                                                                            value={work.from ? dayjs(work.from) : null}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        End Date
                                                                    </label>
                                                                    <div className="input-icon-start position-relative">
                                                                        <span className="input-icon-addon">
                                                                            <i className="isax isax-calendar" />
                                                                        </span>

                                                                        <DatePicker
                                                                            name="to"
                                                                            className={`form-control datetimepicker${dateErrors[index] ? ' is-invalid' : ''}`}
                                                                            getPopupContainer={getModalContainer}
                                                                            placeholder="Select Date"
                                                                            format="DD/MM/YYYY"
                                                                            disabled={work.stillWorking === 'yes'}
                                                                            onChange={(date) => {
                                                                                updateWorkExp(index, {
                                                                                    name: 'to',
                                                                                    value: date ? date.format('YYYY-MM-DD') : ''
                                                                                });
                                                                            }}
                                                                            value={work.to ? dayjs(work.to) : null}
                                                                        />
                                                                    </div>
                                                                    {dateErrors[index] && (
                                                                        <div className="invalid-feedback d-block text-danger fs-12 mt-1">
                                                                            {dateErrors[index]}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Currently working here?
                                                                    </label>
                                                                    <CustomSelect
                                                                        options={[
                                                                            { label: 'Yes', value: 'yes' },
                                                                            { label: 'No', value: 'no' },
                                                                        ]}
                                                                        className="select d-flex"
                                                                        placeholder="Select"
                                                                        name="stillWorking"
                                                                        value={work.stillWorking || ''}
                                                                        onChange={(selectedOption) => {
                                                                            updateWorkExp(index, {
                                                                                name: 'stillWorking',
                                                                                value: selectedOption.value
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-md-12">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Description
                                                                    </label>
                                                                    <textarea
                                                                        rows={4}
                                                                        className="form-control"
                                                                        defaultValue=""
                                                                        name="description"
                                                                        value={work.description || ''}
                                                                        onChange={(e) => {
                                                                            updateWorkExp(index, {
                                                                                name: e.target.name,
                                                                                value: e.target.value
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            ))
                                        ) : (
                                            <p>No work experience added yet.</p>
                                        )}


                                        <div className="d-flex justify-content-end mt-3">
                                            <button
                                                className="btn btn-outline-secondary rounded-pill"
                                                type="submit"
                                                onClick={addWorkExp}
                                            >
                                                Add Work Experience
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <button
                                    className="btn btn-secondary rounded-pill"
                                    type="submit"
                                    onClick={updateProfile}
                                >
                                    Save
                                </button>
                                {msg.loading &&
                                    <span className="mt-3 fs-14 fw-normal d-flex align-items-center justify-content-center">Updating details...</span>
                                }
                                {!msg.loading &&
                                    <span className={`mt-3 ${msg.error ? 'text-red' : ''} fs-14 fw-normal d-flex align-items-center justify-content-center`}>{msg.text}</span>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SettingsModal />
        </>
    );
};

export default StudentWorkExperience;
